/* eslint-disable max-len,array-bracket-newline */
import {
    useCallback,
    useMemo,
} from 'react'
import {
    GridSlotProps,
} from '@mui/x-data-grid-pro'

import useDataGridSource from 'app/shared-components/SkyNetMasterDataGrid/hooks/useDataGridSource'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import SkyNetDataGrid from 'app/shared-components/SkyNetDataGrid'
import requests from 'app/requests/Order/Order.requests'
import containerRequests from 'app/requests/Container/Container.requests'
import useOrderManagementRoutes from 'app/SkyNetRoutes/hooks/useOrderManagementRoutes'
import useContainerManagementRoutes from 'app/SkyNetRoutes/hooks/useContainerManagementRoutes'
import useLabel from 'app/hooks/useLabel'

import useStyles from './ContainersDashboardDemoPage.styles'
import {
    containerSelectionColumns,
    internalTransportColumns,
    containersWrongPairingsColumns,
} from './ContainersDashboardDemoPage.columns'
import AccordionList from './components/ReorderableAccordionList/ReorderableAccordionList'

const containerSelectionRequestConst = requests.customerTransports()
const internalTransportsRequestConst = requests.internalTransports()
const containersWrongPairingsRequestConst = containerRequests.wrongPairings()

const slotProps = {
    footer: {
        showAlways: true,
    },
    pagination: {
        showAlways: true,
    },
}

enum ContainerSelectionTables {
    CustomerTransports = 'customerTransports',
    InternalTransports = 'internalTransports',
    WrongPairings = 'wrongPairings',
}

const ContainersDashboardDemoPage = () => {
    const {
        classes,
    } = useStyles()
    const l = useLabel()

    const ContainerManagementRoutes = useContainerManagementRoutes()
    const OrderManagementRoutes = useOrderManagementRoutes()
    const containerSelectionDataSource = useDataGridSource({
        request: containerSelectionRequestConst,
        key: 'container-selection-customer-transports' as RequestKeys,
    })
    const internalTransportDataSource = useDataGridSource({
        request: internalTransportsRequestConst,
        key: 'container-selection-internal-transports' as RequestKeys,
    })
    const containersWrongPairingsDataSource = useDataGridSource({
        request: containersWrongPairingsRequestConst,
        key: 'container-selection-wrong-pairings' as RequestKeys,
    })

    const onRowClick = useCallback((name, rowData: {row: {
            orderNumber,
            serialNumber,
        } }) => {
        switch (name) {
        case ContainerSelectionTables.CustomerTransports:
        default:
            return OrderManagementRoutes.CustomerOrders.ContainerSelection.navigate({
                params: {
                    key: rowData.row.orderNumber,
                },
            })
        case ContainerSelectionTables.InternalTransports:
            return OrderManagementRoutes.InternalOrders.ContainerSelection.navigate({
                params: {
                    key: rowData.row.orderNumber,
                },
            })
        case ContainerSelectionTables.WrongPairings:
            return ContainerManagementRoutes.Containers.Overview.navigate({
                params: {
                    key: rowData.row.serialNumber,
                },
            })
        }
    }, [
        OrderManagementRoutes,
        ContainerManagementRoutes,
    ])

    const tableItems = useMemo(() => {
        return [
            {
                title: l('CUSTOMER_TRANSPORTS'),
                key: 'demo-containers-dashboard-upcoming-selection-table',
                renderContent: (height) => {
                    return (
                        <SkyNetDataGrid
                            // TODO-JM: use persistent key from persistent key enums when not demo page
                            persistentKey="demo-containers-dashboard-upcoming-selection-table"
                            columns={containerSelectionColumns}
                            customDataSource={containerSelectionDataSource}
                            toolbarProps={{
                                title: l('UPCOMING_CONTAINER_SELECTION'),
                                showQuickFilter: true,
                            }}
                            onRowClick={(args) => {
                                onRowClick(ContainerSelectionTables.CustomerTransports, args)
                            }}
                            slotProps={slotProps as unknown as GridSlotProps}
                            height={height}
                            classNames={{
                                container: classes.dataGridContainer,
                            }}
                        />
                    )
                },
            },
            {
                title: l('INTERNAL_TRANSPORTS'),
                key: 'demo-containers-dashboard-internal-transport-table',
                renderContent: (height) => {
                    return (
                        <SkyNetDataGrid
                            // TODO-JM: use persistent key from persistent key enums when not demo page
                            persistentKey="demo-containers-dashboard-internal-transport-table"
                            columns={internalTransportColumns}
                            customDataSource={internalTransportDataSource}
                            toolbarProps={{
                                title: l('OPEN_TRANSPORTS'),
                                showQuickFilter: true,
                            }}
                            onRowClick={(args) => {
                                onRowClick(ContainerSelectionTables.InternalTransports, args)
                            }}
                            slotProps={slotProps as unknown as GridSlotProps}
                            height={height}
                            classNames={{
                                container: classes.dataGridContainer,
                            }}
                        />
                    )
                },
            },
            {
                title: l('CONTAINER_MONITORING'),
                key: 'demo-containers-dashboard-containers-wrong-pairings-table',
                renderContent: (height) => {
                    return (
                        <SkyNetDataGrid
                            // TODO-JM: use persistent key from persistent key enums when not demo page
                            persistentKey="demo-containers-dashboard-containers-wrong-pairings-table"
                            columns={containersWrongPairingsColumns}
                            customDataSource={containersWrongPairingsDataSource}
                            toolbarProps={{
                                title: l('WRONG_PAIRINGS'),
                                showQuickFilter: true,
                            }}
                            onRowClick={(args) => {
                                onRowClick(ContainerSelectionTables.WrongPairings, args)
                            }}
                            slotProps={slotProps as unknown as GridSlotProps}
                            height={height}
                            classNames={{
                                container: classes.dataGridContainer,
                            }}
                        />
                    )
                },
            },
        ]
    }, [
        containerSelectionDataSource,
        containersWrongPairingsDataSource,
        internalTransportDataSource,
        onRowClick,
        l,
        classes,
    ])

    return (
        <div
            className={classes.root}
        >
            <AccordionList
                initialHeightVh={23}
                items={tableItems}
                // TODO-JM: use persistent key from persistent key enums when not demo page
                persistentKey="demo-containers-dashboard-list"
            />
        </div>
    )
}

export default ContainersDashboardDemoPage
